import { mapState } from 'vuex'

const i18nMixin = {
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang
    })
  },
  methods: {
    setLang (lang, reload) {
      this.$store
        .dispatch('SetLang', lang)
        .then(async () => {
          window.location.reload(false)
        })
    }
  }
}

export default i18nMixin
